export default {
  "content": "<path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 24 24",
    "stroke-width": "1.5",
    "stroke": "currentColor",
    "class": "size-6"
  }
};